import "./Terms.scss";
import { Content } from "antd/es/layout/layout";
import { theme } from "antd";
import {
  FileTextOutlined,
  UserOutlined,
  SettingOutlined,
  DollarOutlined,
  CloseCircleOutlined,
  SafetyOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import {
  HeroCard,
  FeatureCard,
  BenefitsCard,
  ContactUs,
} from "../../components";

export default function Terms() {
  const { useToken } = theme;
  const { token } = useToken();

  const heroData = {
    icon: <FileTextOutlined style={{ color: "#fff", fontSize: 40 }} />,
    title: "Terms of Service",
    badge: "Currently in Effect",
    description:
      "By accessing and using BlackList420, you acknowledge and agree to be bound by the following terms and conditions. BlackList420 reserves the right to update these Terms of Service periodically. We will provide a seven (7) day notice before any significant changes take effect. Your continued use of the Service constitutes acceptance of the new Terms.",
  };

  const features = [
    {
      icon: <UserOutlined />,
      title: "Account Terms",
      description:
        "Must be 18+, maintain secure credentials, and comply with all laws",
    },
    {
      icon: <SettingOutlined />,
      title: "General Conditions",
      description:
        "Service provided as-is with technical support for account holders",
    },
    {
      icon: <DollarOutlined />,
      title: "Payments & Refunds",
      description: "Subscription model with 60-day notice for pricing changes",
    },
    {
      icon: <CloseCircleOutlined />,
      title: "Cancellation",
      description:
        "Cancel anytime through support with all content deleted upon cancellation",
    },
  ];

  const sections = [
    {
      icon: <UserOutlined />,
      title: "Account Terms",
      content: [
        "You must be at least 18 years old to use this Service",
        "Account registration requires your legal name, valid email address, and other necessary information",
        "Accounts are personal and cannot be shared or used by more than one individual",
        "You are responsible for maintaining the confidentiality of your account and password",
        "You accept responsibility for all activities that occur under your account",
        "The use of the Service for illegal activities is prohibited",
        "Compliance with all local laws is required",
        "You must secure and provide evidence of all necessary business licenses and comply with tax laws",
      ],
    },
    {
      icon: <SettingOutlined />,
      title: "General Conditions",
      content: [
        "BlackList420 provides its services under these Terms of Service",
        "The Service is provided on an 'as is' and 'as available' basis without warranties of any kind",
        "BlackList420 owns all rights to its platform, including any developments and modifications",
        "Technical support is available to paying account holders according to service agreement terms",
        "BlackList420 may remove content or terminate accounts that violate these Terms of Service",
      ],
    },
    {
      icon: <DollarOutlined />,
      title: "Payments, Refunds & Modifications",
      content: [
        "BlackList420 operates on a subscription model with terms outlined in your Service Agreement",
        "No refunds for partial service periods or unused service with an open account",
        "BlackList420 reserves the right to modify or discontinue the Service with notice",
        "Pricing may change with sixty (60) days advance notice provided",
        "Notice of pricing changes will be given well in advance",
      ],
    },
    {
      icon: <CloseCircleOutlined />,
      title: "Cancellation and Termination",
      content: [
        "Accounts can be canceled by contacting BlackList420 support with a cancellation request",
        "Upon cancellation, all content will be irretrievably deleted",
        "You are responsible for all charges incurred up to the time of cancellation",
      ],
    },
    {
      icon: <SafetyOutlined />,
      title: "Warranties and Liability",
      content: [
        "BlackList420 disclaims all liability for damages that may arise from use or inability to use the Service",
        "Users are responsible for ensuring their use of the Service complies with all applicable laws and regulations",
      ],
    },
    {
      icon: <CheckCircleOutlined />,
      title: "Miscellaneous",
      content: [
        "This Agreement constitutes the entire agreement between you and BlackList420 regarding use of the Service",
        "These Terms of Service will be governed by the laws of the jurisdiction where BlackList420 is headquartered",
      ],
    },
  ];

  return (
    <Content className="terms-cont">
      {/* Hero Section */}
      <HeroCard token={token} {...heroData} />

      {/* Terms Features Grid */}
      <div className="terms-cont__features">
        {features?.map((feature, index) => (
          <FeatureCard
            key={index}
            feature={feature}
            index={index}
            token={token}
          />
        ))}
      </div>

      {/* Main Content Section */}
      <div className="terms-cont__mainContent">
        {sections.map((section, index) => (
          <BenefitsCard
            key={index}
            title={section.title}
            icon={section.icon}
            impactPoints={section?.content?.map((text) => ({
              icon: (
                <CheckCircleOutlined
                  style={{
                    color:
                      index % 2 === 0
                        ? token?.colorPrimary
                        : token?.colorSecondaryLogo,
                  }}
                />
              ),
              text,
            }))}
            token={token}
            borderColor={
              index % 2 === 0 ? token?.colorPrimary : token?.colorSecondaryLogo
            }
          />
        ))}
      </div>
      <ContactUs token={token} />
    </Content>
  );
}
